// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";
import { useGetAgentsByAgency } from "../../hooks/useGetAgents";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import LoadingIndicator from "../Loaders/LoadingIndicator";
import ServerError from "../Error/ServerError";
import AgentsSection from "../AboutUs/AgentsSection";
import WidgetContacts from "../Widgets/WidgetContacts/WidgetContacts";
import WidgetPartners from "../Widgets/WidgetPartners/WidgetPartners";

// CONFIGURAZIONI
import { appConfig, AGENCY_ID } from "../../config/appConfig";

interface ServicesProps {
    agencyId: number;
    showAgents: boolean;
}


const Services: React.FC<ServicesProps> = ({ agencyId, showAgents }) => {
    const { t } = useTranslation();
    const partners = appConfig.content.partners;

    const services = [
        [
            t('servicesPage.list1.service1'),
            t('servicesPage.list1.service2'),
            t('servicesPage.list1.service3'),
            t('servicesPage.list1.service4'),
            t('servicesPage.list1.service5'),
            t('servicesPage.list1.service6'),
            t('servicesPage.list1.service7')
        ],
        [
            t('servicesPage.list2.service1'),
            t('servicesPage.list2.service2'),
            t('servicesPage.list2.service3'),
        ]
    ]

    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(AGENCY_ID);
    const { agents, loading: agentsLoading, error: agentsError } = useGetAgentsByAgency(agencyId);

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;

    return (
        <>
            <Helmet>
                <title>{t('navigation.servicesLinkTitle')} | {agency?.agencyName ?? t('common.defaultAgencyName')}</title>
            </Helmet>

            <SubHeaderDefault title={t('navigation.servicesLinkTitle')} isSeo={true}/>

            <main id="page" className="services-page space-ptb">
                <div className="container-fluid w-90">
                    <div className="row">
                        <div className="col-12 col-xl-9 mb-4 mb-xl-0">
                            
                            <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para1') as string }} />
                            <p  className="mb-2" dangerouslySetInnerHTML={{ __html: t('servicesPage.para2') as string }} />
                            <ul>
                                {services[0].map((service, index) => (
                                    <li key={`${index}`}>{service}</li>
                                ))}
                            </ul>
                            <p className="mb-2" dangerouslySetInnerHTML={{ __html: t('servicesPage.para3') as string }} />
                            <ul>
                                {services[1].map((service, index) => (
                                    <li key={`${index}`}>{service}</li>
                                ))}
                            </ul>
                            <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para4') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para5') as string }} />

                            <AgentsSection
                                showAgents={showAgents}
                                agents={agents}
                                agentsLoading={agentsLoading}
                                agentsError={agentsError}
                            />
                        </div>
                        <div className="col-12 col-xl-3">
                            <div className="row sidebar">
                                <div className="col-12 col-md-6 col-xl-12">
                                    <WidgetContacts
                                        agencyDataAddress={agency?.address_details?.address ?? ''}
                                        agencyDataCity={agency?.address_details?.city_name ?? ''}
                                        agencyDataComuneCapoluogo={agency?.address_details?.city_name === agency?.address_details?.province_name}
                                        agencyDataProvinciaSigla={agency?.address_details?.sigla ?? ''}
                                        agencyDataEmail={''}
                                        agencyDataEmailShow={false}
                                        agencyDataPhone1={agency?.phone1 ?? ''}
                                        agencyDataPhone2={agency?.phone2 ?? ''}
                                        agencyDataInternationalPrefix={'+39'}
                                        agencyDataMobile={agency?.mobile ?? ''}
                                        agencyDataMobile2={agency?.mobile2 ?? ''}
                                        agencyDataWhatsapp={''}
                                        agencyDataFacebook={''}
                                        agencyDataInstagram={''}
                                        agencyDataTwitter={''}
                                        agencyDataLinkedin={''}
                                        agencyDataPinterest={''}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-xl-12">
                                    <WidgetPartners partners={partners} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Services;